import type { OrderDetails } from '../services/orders.service';

/**
 * Whether the per-pro "Send Haz Docs" button should show.
 *
 * Mirrors the v1 lib_editrecord.pl `$inlinehazdocbutton` gate: a non-template,
 * non-deleted EXPORT with a container, headed out via a pre-advise haz rail, that
 * hasn't been trace-terminated, pre-advised, or had haz docs requested yet, AND
 * has at least one HAZ-MAT PAPERWORK document on file (`hasHazDocs`, computed
 * server-side on the order-details read).
 *
 * v1 list/track-only guards (isGWITrack / $global_notgwi) don't apply on the /pro
 * edit page and are dropped, same as computeRailBillingEligibility.
 */
const PREADVISE_HAZ_RAILS = new Set(['HOU-BCT', 'HOU-BPT', 'BTM-SMT']);

export function computeHazDocsEligibility(od: OrderDetails | null | undefined): boolean {
  if (!od) return false;
  const isTemplate = od.template === 'Y';
  const isDeleted = od.addlInfoDeleted === 'Y';
  const isExport = od.moveType === 'EXPORT';
  const hasContainer = Boolean((od.container || '').trim());
  const notTerminated = !(od.traceTerminateDatetime || '').trim();
  const notRequested = !(od.hazReqDatetime || '').trim();
  const notPreadvised = !(od.preAdviseDatetime || '').trim();
  const onHazRail = PREADVISE_HAZ_RAILS.has((od.rail || '').trim());
  const hasDocs = Boolean(od.hasHazDocs);

  return (
    !isTemplate &&
    !isDeleted &&
    isExport &&
    hasContainer &&
    notTerminated &&
    notRequested &&
    notPreadvised &&
    onHazRail &&
    hasDocs
  );
}
